'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ItemQuantityDesktop = require('./ItemQuantityDesktop.js');
var ItemQuantityMobile = require('./ItemQuantityMobile.js');
var ItemQuantityViewRoot = require('../../../../common/views/ItemQuantity/ItemQuantityViewRoot.js');
var useIsMobile = require('../../../../common/providers/useIsMobile.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemQuantity = () => {
  const isMobile = useIsMobile["default"]();
  const computeMaxQuantity = _ref => {
    var _currentItemDetails$e;
    let {
      currentItemClaim,
      currentItemDetails
    } = _ref;
    return Math.min(((_currentItemDetails$e = currentItemDetails.eligibility) === null || _currentItemDetails$e === void 0 ? void 0 : _currentItemDetails$e.eligibleQuantity) || 0, (currentItemDetails.remainingEligibleQuantity || 0) + (currentItemClaim.quantity || 0));
  };
  return /*#__PURE__*/React__default["default"].createElement(ItemQuantityViewRoot["default"], {
    computeMaxQuantity: computeMaxQuantity
  }, isMobile ? /*#__PURE__*/React__default["default"].createElement(ItemQuantityMobile["default"], null) : /*#__PURE__*/React__default["default"].createElement(ItemQuantityDesktop["default"], null));
};

exports["default"] = ItemQuantity;
